import { ChangeDetectionStrategy, Component, OnInit, inject, input } from "@angular/core";
import { MatChip } from "@angular/material/chips";
import { MatIcon } from "@angular/material/icon";
import { DebugModeService } from "../../../../services/debug-mode.service";
import type { ToolFrontendData, BlockStatus } from "../../../../model/block.types";

/**
 * @deprecated Use MapFrontendToolsService (CopilotKit frontend tools) instead.
 * This component executed map actions from LangGraph state snapshot blocks, but
 * frontend tools are now handled by CopilotKit's tool execution pipeline which
 * returns results to the backend. Kept temporarily for reference — remove once
 * MapFrontendToolsService covers all cases.
 */
@Component({
  selector: "app-tool-frontend-executor",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatChip, MatIcon],
  templateUrl: "./tool-frontend-executor.component.html",
  styleUrl: "./tool-frontend-executor.component.scss",
})
export class ToolFrontendExecutorComponent implements OnInit {
  data = input.required<ToolFrontendData>();

  status = input.required<BlockStatus>();

  protected readonly debugMode = inject(DebugModeService);

  ngOnInit(): void {
    // no-op — frontend tools are now executed by CopilotKit via MapFrontendToolsService
  }
}
